// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderAddTwoToneSvg from "@fishx/icons-svg/es/asn/FolderAddTwoTone";
import FishxIcon from '../components/FishxIcon';

var FolderAddTwoTone = function FolderAddTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderAddTwoToneSvg
  }));
};

FolderAddTwoTone.displayName = 'FolderAddTwoTone';
export default React.forwardRef(FolderAddTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FolderAddTwoTone.js
// module id = 2795
// module chunks = 0